import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./global.css";
import App from "./App";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./configs/authConfig";
import { AuthProvider } from "./contexts/AuthContext";
import { TimePeriodProvider } from "./contexts/TimePeriodContext";

const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <MsalProvider instance={msalInstance}>
    <AuthProvider>
      <TimePeriodProvider>
        <App />
      </TimePeriodProvider>
    </AuthProvider>
  </MsalProvider>,
);
